import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPrompt1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPrompt1"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM10.25 10.25L7 11.5V12.5L10.25 13.75L11.5 17H12.5L13.75 13.75L17 12.5V11.5L13.75 10.25L12.5 7H11.5L10.25 10.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPrompt1;
